"use client";

import { useEffect } from "react";
import { ErrorState } from "@/components/site/ErrorState";
import { FAVICON_GRAY_DATA_URI } from "@/lib/favicon-gray";
import "./globals.css";

/** Last-resort boundary when the root layout itself throws (must render <html>). */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <html lang="fa-IR" dir="rtl">
      <head>
        <title>سرویس موقتاً در دسترس نیست</title>
        {/* The root layout (and its icons) is gone here — grey tab icon inline */}
        <link rel="icon" type="image/png" href={FAVICON_GRAY_DATA_URI} />
      </head>
      <body style={{ fontFamily: "Vazirmatn, Tahoma, system-ui, sans-serif" }}>
        <main id="main-content">
          <ErrorState
            code="۵۰۰"
            title="سرویس موقتاً در دسترس نیست"
            lead="در حال رفع مشکل هستیم. چند لحظه دیگر دوباره تلاش کنید یا با ما تماس بگیرید."
            reference={error.digest}
            onRetry={reset}
          />
        </main>
      </body>
    </html>
  );
}
